export default __webpack_public_path__ + "baf80da65eb17470c82512ce989786d8.png";